import { useContext, useEffect } from "react";
import { SmartContext } from "../../../../../library/Core/SmartContext";
import { allowPerformAction, getActionElementClass, getDomainValueForCode } from "../../../../../library/Core/SmartFunctions";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "bootstrap";

const RecruiterProfileInformation = () => {
  const { state } = useContext(SmartContext);
  const navigate = useNavigate();
  const profile = state?.data?.profile;
  const recruiterInfo = state?.data?.recruiterInfo || {};

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll("[data-bs-toggle='tooltip']")
    );
    tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
  }, []);

  const isPeerReviewed = sessionStorage.getItem("is-peer-reviewed") === "true";
  const userType = sessionStorage.getItem("user-type-code");
  const isPersonate =
    sessionStorage.getItem("is-impersonated-session") === "YES";

  // if (!isPersonate && userType === "ALUMNI" && !isPeerReviewed) {
  //   window.location.href = `/alumni/welcome`;
  //   return null;
  // }

  let maskedLocalPart = "";
  if (profile?.contactEmailId) {
    const [localPart, domain] = profile.contactEmailId.split("@");
    maskedLocalPart =
      localPart[0] + localPart.slice(1).replace(/./g, "x") + "@" + domain;
  }

  const handleSendMessage = (event: any, id: string) => {
        event.preventDefault();
        if ( !allowPerformAction() ) return;
        
        navigate(`/messages/${id}`);
    };

  return (
    <div
      className="tab-pane fade active show"
      id="pills-profileInformation"
      role="tabpanel"
      aria-labelledby="pills-profileInformation-tab"
    >
      <div className="underGraduate-detail">
        <div className="blockHeader">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="title d-flex align-items-center">
                <i className="icon icon-user me-2"></i>
                <span>Recruiter Profile Information</span>
              </div>
            </div>
            <div className="col-auto">
              <a
                href="javascript:;"
                className={`btn-add-section ${getActionElementClass()}`}
                onClick={() => {
                  if (allowPerformAction()) {
                    navigate(`/alumni/${state?.data?.id}/recruiter-basic-info`);
                  }
                }}
              >
                <b className="icon icon-edit me-2"></b>
                <span>{recruiterInfo?.email ? "EDIT" : "ADD"}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mx-auto">
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <div className="row g-2">
                                        <div className="col-sm-4 d-flex"><label className="form-label m-0 mb-1 font-20 font-500 w-100">E-Mail </label><b>:</b></div>
                                        <div className="col-sm-8"><span className="font-16 text-gray-64">{state?.data?.recruiterInfo?.email}</span></div>
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <div className="row g-2">
                                        <div className="col-sm-4 d-flex"><label className="form-label m-0 mb-1 font-20 font-500 w-100">Company</label><b>:</b></div>
                                        <div className="col-sm-8"><span className="font-16 text-gray-64">{state?.data?.recruiterInfo?.companyId ? getDomainValueForCode(state?.data?.recruiterInfo?.companyId,'COMPANY_CODE',state) : state?.data?.recruiterInfo?.otherCompany}</span></div>
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <div className="row g-2">
                                        <div className="col-sm-4 d-flex"><label className="form-label m-0 mb-1 font-20 font-500 w-100">Mobile</label><b>:</b></div>
                                        <div className="col-sm-8"><span className="font-16 text-gray-64">{state?.data?.recruiterInfo?.countryCode ? '+'+state?.data?.recruiterInfo?.countryCode : ''} {state?.data?.recruiterInfo?.mobileNumber}</span></div>
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <div className="row g-2">
                                        <div className="col-sm-4 d-flex"><label className="form-label m-0 mb-1 font-20 font-500 w-100">Comments</label><b>:</b></div>
                                        <div className="col-sm-8"><span className="font-16 text-gray-64">{state?.data?.recruiterInfo?.comment}</span></div>
                                    </div>
                                  </div>

                              <div className="col-md-12">
                                <label className="form-label m-0 mb-1 font-18 font-500 w-100">Below are the roles</label>
                                
                                <div className="table-responsive attendee_dtl withborder">
             
                                    <table id="example1" className="table">
                                      <thead>
                                        <tr>
                                          <th style={{width:"150"}}>Role </th>
                                          <th style={{width:"150"}}>Expected CTC (LPA) </th>
                                          <th>Work-Ex Preference (Years)</th>
                                          <th>Number of Offers</th>
                                          <th>Program </th>
                                          <th>Location</th>                         
                                        </tr>
                                      </thead>
                                      <tbody>   
                                        {state?.data?.recruiterInfo?.recruiterJobs && state?.data?.recruiterInfo?.recruiterJobs.length > 0 ? (
                                          state.data.recruiterInfo.recruiterJobs.map((job: any, index: number) => {
                                            const roleValue = getDomainValueForCode(job.role, 'FUNCTIONAL_AREA_CODE', state);
                                            const programValue = getDomainValueForCode(job.programId, 'ALL_PROGRAM_CODE',state);
                                            const country = getDomainValueForCode(job.jobCountryCode, 'COUNTRY_CODE',state);
                                            const city = getDomainValueForCode(job.jobCityCode, 'CITY_CODE',state);
                                            const ctc = job.appxCTC ? job.appxCTC?.replace(/_/g, '-') : '-';
                                            const numberOfOffers = job.expectedNumbersOfOffers ? job.expectedNumbersOfOffers?.replace(/_/g, '-') : '-';
                                            const workEx = job.workPreference ? job.workPreference?.replace('_', '-').replace('_', ' ') : '-';
                                            return (
                                            <tr key={index}>
                                                <td>{roleValue}</td>
                                                <td>{ctc}</td>
                                                <td>{workEx}</td>
                                                <td>{numberOfOffers}</td>
                                                <td>{programValue}</td>
                                                <td>{city ? `City - ${city}` : ''}
                                                <br/>{country ? `Country - ${country}` : ''}</td>
                                              </tr>
                                            )  
                                          })

                                            ) : (
                                              <tr>
                                                <td colSpan={5} className="text-center">
                                                  No roles available
                                                </td>
                                              </tr>
                                            )}                  
                                      </tbody>
                                    </table>
                                  </div>
                              </div>
          
                         


      
                              <div className="col-sm-12">
                                <div className="action_btns mt-3">
                                  <button type="button" 
                                    className={`btn btn-green my-2 my-sm-0 height-45 px-5 ${getActionElementClass()}`}
                                    onClick={(event) => handleSendMessage(event, state?.data?.id)}
                                  ><span>Send A Message</span></button>
                              </div>
                              </div>
      
                            </div>
          
                          </div>
        
      </div>
    </div>
  );
};

export default RecruiterProfileInformation;
